import ChevronLeft from '@ixigo/icons/ChevronLeft';
import {
	NavigationAction,
	NavigationContainer,
	NavigationHeader as NavigationHeaderComponent,
	NavigationTitle,
} from '@ixigo/iui/NavigationHeader';
import cn from '@repo/shared/utils/cn';

interface NavigationHeaderProps {
	title: string;
	subtitle?: string;
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	leftAction?: () => void;
	rightAction?: () => void;
	className?: string;
}

/**
 * NavigationHeader component wrapper using @ixigo/iui NavigationHeader
 * A flexible header component with back button, title, and optional icons
 *
 * @param title - Header title to display
 * @param onBackClick - Callback for back button click
 * @param leftIcon - Custom left icon (overrides default back icon)
 * @param rightIcon - Optional right icon
 * @param backgroundColor - Background color for the header
 * @param titleColor - Color for the title text
 * @param className - Additional CSS classes
 */
export function NavigationHeader({
	title,
	subtitle = '',
	leftIcon = <ChevronLeft className="w-6 h-6" />,
	rightIcon,
	leftAction,
	rightAction,
	className = 'sticky top-0 z-[1] w-full px-20 flex-nowrap',
}: NavigationHeaderProps) {
	return (
		<NavigationHeaderComponent className={className}>
			<NavigationContainer
				type="left"
				className={cn('w-[10%] py-2.5 ', !leftAction && 'invisible')}
			>
				<NavigationAction content={leftIcon} onClick={() => leftAction?.()} />
			</NavigationContainer>
			<NavigationContainer type="center" className="overflow-hidden">
				<NavigationTitle
					primary={title}
					secondary={subtitle}
					className="[&>h5]:truncate text-center"
				/>
			</NavigationContainer>
			<NavigationContainer
				type="right"
				className={cn('w-[10%] py-2.5 shrink-0', !rightAction && 'invisible')}
			>
				<NavigationAction content={rightIcon} onClick={() => rightAction?.()} />
			</NavigationContainer>
		</NavigationHeaderComponent>
	);
}
